import { BaseModel } from './baseModel';

export class Workflow extends BaseModel {
  constructor(
    public name: string
  ) { super(); }
}
